import { useMemo } from "react";

import { BONUS_TYPE_TRANSLATION } from "constants/bonus.constants.js";
import { GAME_TYPE, GAME_TYPE_MAPPER } from "constants/game.constants.js";
import { useTranslation } from "react-i18next";
import { binaryToFlags } from "utils/binaryCalculations.js";
import getBonusAmountInfo from "utils/bonus.js";
import isNullOrUndefined from "utils/typeChecks/isNullOrUndefined.js";
import isEmptyArray from "utils/typeChecks/isEmptyArray.js";

import getStringDateAvailableUntil from "../../helpers/getStringDateAvailableUntil";
import BonusGameCards from "../bonusGameCards";
import moment from "moment/moment.js";
import { DATE_TIME_FORMAT } from "constants/date.constants.js";


const SingleTypeBonusCard = ({ bonuses = [], currencyCode, isMobile, isTablet, assignedGameTypes }) => {
	const { t } = useTranslation();

	const bonus = bonuses.at(0);

	const stringDateAvailableUntil = getStringDateAvailableUntil({ bonus });

	const bonusTypeInfoText = t(BONUS_TYPE_TRANSLATION[bonus.bonusType]);

	const amountInfo = getBonusAmountInfo({ bonus, currencyCode });

	const bonusGamesInfoText = useMemo(() => {
		if (isNullOrUndefined(assignedGameTypes) || isEmptyArray(assignedGameTypes)) {
			return "";
		}
		const allGames = binaryToFlags(assignedGameTypes, bonus.gameType);
		if (allGames.length === 1) {
			return t(`common.${GAME_TYPE_MAPPER[allGames[0]]}`);
		}
		if (Object.values(GAME_TYPE).length === allGames.length) {
			return t("common.allGames");
		}

		return `${allGames.length} ${t("bonus.games")}`;
	}, [assignedGameTypes, bonus.gameType, t]);

	return (
		<div className="vs--bonus-modal-notification-info-content vs--bonus-modal-notification-info-content-single-type">
			<h3 className="vs--bonus-modal-notification-info-title">
				{t("bonus.youReceived").replace("{info}", bonusTypeInfoText)}
			</h3>
			<p className="vs--bonus-modal-notification-info-subtitle">
				<span className="brand-color-text">{amountInfo}</span>
				&nbsp;
				<span
					dangerouslySetInnerHTML={{
						__html: t("bonus.availableFor").replace(
							"{what}",
							`<span class="vs--font-bold">${bonusGamesInfoText}</span>`
						)
					}}
				/>
			</p>
			<BonusGameCards gameType={bonus.gameType} isMobile={isMobile} isTablet={isTablet} />
			<div className="vs--bonus-modal-notification-info-footer">
				<span className="vs--ff-primary vs--fs-12 vs--fw-400 vs--tc-gray">
					{`${moment.utc(bonus.startDate).format(DATE_TIME_FORMAT)} - ${moment.utc(bonus.endDate).format(DATE_TIME_FORMAT)}`}
				</span>
			</div>
		</div>
	);
};

export default SingleTypeBonusCard;
